<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>现货币种设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create-currency-introduction
          @refresh="refreshList"
        ></create-currency-introduction>
        <el-select v-model="coin" placeholder="请选择状态">
          <el-option
            v-for="item in coinArr"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <el-select v-model="isOpen" placeholder="请选择状态">
          <el-option
            v-for="item in typeArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button type="primary" @click="handleSearch({ page: 1, size: 25 })"
          >搜索</el-button
        >
      </div>
      <currency-introduction-list
        @refresh="refreshList"
      ></currency-introduction-list>
    </el-card>
  </div>
</template>

<script>
import CurrencyIntroductionList from "./components/list";
import CreateCurrencyIntroduction from "./components/create";
import "./store";
import { mapActions, mapState } from "vuex";
import api from "./api";
import { PAGINATION } from 'common/config';
export default {
  name: "CurrencyIntroduction",
  data() {
    return {
      coin: "",
      coinArr: [],
      isOpen: '',
      typeArr: [
        { label: "全部", value: "" },
        { label: "开", value: true },
        { label: "关", value: false },
      ],
    };
  },
  components: {
    CurrencyIntroductionList,
    CreateCurrencyIntroduction,
  },
  computed: {
  },
  methods: {
    ...mapActions("spotCoinAdminStore", ["list"]),
    refreshList(data = {}) {
      this.handleSearch(data);
    },
    handleSearch(data = {}) {
      this.list({
        coin: this.coin,
        isOpen: this.isOpen,
        ...PAGINATION,
        page: 1,
        ...data,
      });
    },
  },
  mounted() {
    api.exchangeCoins().then((res) => {
      if (res.code == 0) {
        this.coinArr = res.data;
      }
    });
    this.handleSearch();
  },
};
</script>

<style lang="less" scoped></style>
